<template>
  <admin-wrapper
    class="pt-8"
    hide-title-row
    disable-sticky-buttons
    disable-body-bottom-padding
    :has-buttons="false"
    :inputs="mappedSettings"
    @change="editSingleSettingHandler"
  />
</template>
<script>
import { get } from 'vuex-pathify';
import AdminWrapper from '@/components/AdminWrapper';
export default {
  name: 'SuperAdminModuleSettings',
  components: { AdminWrapper },
  props: {
    module: {
      type: String,
      required: true,
    },
    settings: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    moduleEnabled: get('admin/additionalModules@:module@enabled'),
    mappedSettings() {
      return this.settings.map(setting => {
        return { ...setting, disabled: !this.moduleEnabled };
      });
    },
  },
  methods: {
    editSingleSettingHandler(value, name) {
      this.$emit('editSingleSetting', value, name);
    },
  },
};
</script>
